import { render, staticRenderFns } from "./DevEnv.vue?vue&type=template&id=2136f12b&scoped=true"
import script from "./DevEnv.vue?vue&type=script&lang=js"
export * from "./DevEnv.vue?vue&type=script&lang=js"
import style0 from "./DevEnv.vue?vue&type=style&index=0&id=2136f12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136f12b",
  null
  
)

export default component.exports